import {useState, useEffect} from "react";
import axiosWithAuth from '../utils/axiosWithAuth';
import {useForm} from 'react-hook-form';
import {useNavigate, useParams} from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';


function AssignUserToProject (props) {

    const {register, handleSubmit, formState: {errors}} = useForm();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [usersList, setUsersList] = useState([]);
    // const [projectsList, setProjectsList] = useState([]);
    const navigate = useNavigate();
    const {organizationId} = useParams();
    const {projectId} = useParams();

    var data = {
        "organizationId": organizationId
    }

    //Get organization's users on page render
    useEffect(() => {
        axiosWithAuth().post(`${process.env.REACT_APP_API_URL}GetOrgUsers`, data)
        .then(response => {
            setUsersList(response.data);
        })
        .catch(error => {

        })
    }, [])


    const onSubmit = (data, e) => {

        setLoading(true);

        data['projectId'] = projectId;

        axiosWithAuth().post(`${process.env.REACT_APP_API_URL}AssignUserToProj`, data)
        .then(response => {
            setLoading(false);
            setMessage("Successfully assigned user to project")
        })
        .catch(error => {
            setLoading(false);
            setMessage("Failed to assign user to project")
        })
    }


    return(  
        <>  
        <Container >
            <Button style={{margin: "2rem 0rem"}} onClick={() => navigate(-1)}>Back</Button> 
            <Card className=" p-5 d-flex align-items-center justify-content-center">
                           
                <h1 style={{paddingTop: "2rem"}}>Assign user to project</h1>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="d-flex align-items-center justify-content-center flex-column" controlId="formAssignUserToProject" bsPrefix="formGroup">

                        <div style={{display: "flex"}}>
                            {/* <div style={{padding: "2rem"}}>
                                <Form.Label for='projects'>Select Project</Form.Label>
                                <Form.Select name="projects" {...register("projectId", {validate: {confirmSelection: v => v != '' || <><i>Please select project</i><br/></>}})}>
                                    <option selected disabled hidden style={{display: "none"}} value=''></option>
                                    {projectsList.map(project => (
                                        <option value={project.projectGUID}>{project.projectName}</option>
                                    ))}
                                </Form.Select>
                                {errors.projectId && <i>{errors.projectId.message}</i>}
                            </div> */}

                            <div style={{padding: "2rem"}}>
                                <Form.Label for='users'>Select User</Form.Label>
                                <Form.Select name="users" {...register("userId", {validate: {confirmSelection: v => v != '' || <><i>Please select user</i><br/></>}})}>
                                    <option selected disabled hidden style={{display: "none"}} value=''></option>
                                    {usersList.map(user => (
                                        <option value={user.userGUID}>{user.firstName} {user.lastName}</option>
                                    ))}
                                </Form.Select>
                                {errors.userId && <i>{errors.userId.message}</i>}
                            </div>
                    
                            <div style={{padding: "2rem"}}>
                                <Form.Label for='roles'>Select Role</Form.Label>
                                <Form.Select name="roles" {...register("roleType")}>
                                    <option value="viewer" selected="selected">Viewer</option>
                                    <option value="admin">Admin</option>
                                </Form.Select>
                            </div>
                        </div>
                        
                        <Button disabled={loading} type='submit' variant="secondary" style={{marginTop: "1rem"}}>Submit</Button> 
                    </Form.Group>       
                </Form>

                {loading &&
                    <Spinner animation="border"/>
                }

                <p>{message}</p>

            </Card>
        </Container>
    </>  
    )
}

export default AssignUserToProject;